import { render, staticRenderFns } from "./DeleteAreas.vue?vue&type=template&id=94c5affa&scoped=true"
import script from "./DeleteAreas.vue?vue&type=script&lang=js"
export * from "./DeleteAreas.vue?vue&type=script&lang=js"
import style0 from "./DeleteAreas.vue?vue&type=style&index=0&id=94c5affa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c5affa",
  null
  
)

export default component.exports